import React from 'react';
import { object } from 'prop-types';
import { connect } from 'react-redux';

import { get } from 'lodash';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import classes from './FaultCardsContainer.module.css';
import clsx from 'clsx';

const FaultCardsContainer = ({
    cardScores
}) => {

    return (
        <div className={classes.FaultCardsContainer}>
            <Card className={clsx(classes.card, classes.highPriority)}>
                <CardContent>
                    <h3>High Priority Faults</h3>
                    <div className={classes.cardNumber}>
                        { get(cardScores, 'high', '0') }
                    </div>
                </CardContent>
            </Card>
            <Card className={clsx(classes.card, classes.mediumPriority)}>
                <CardContent>
                    <h3>Medium Priority Faults</h3>
                    <div className={classes.cardNumber}>
                        { get(cardScores, 'medium', '0') }
                    </div>
                </CardContent>
            </Card>
            <Card className={clsx(classes.card, classes.lowPriority)}>
                <CardContent>
                    <h3>Low Priority Faults</h3>
                    <div className={classes.cardNumber}>
                        { get(cardScores, 'low', '0') }
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

FaultCardsContainer.defaultProps = {
    cardScores: {}
};

FaultCardsContainer.propTypes = {
    cardScores: object.isRequired
};

const mapStateToProps = state => {
    return {
        cardScores: state.home.cardScores
    };
};

export default connect(mapStateToProps, null)(FaultCardsContainer);

